import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import DefaultButton from "../../../../../component/base/DefaultButton";
import { CircularProgress } from "@material-ui/core";
import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css"; // Importação do CSS do KaTeX

const ModalFormula = (props: any) => {
  const { showModal, setShowModal, setImage } = props;
  const [value, setValue] = useState("");
  const [msgErro, setMsgErro] = useState("");
  const [loadingFormula, setLoadingFormula] = useState(false);

  const handleSaveFormula = (e: any) => {
    e.preventDefault();
    setLoadingFormula(true);

    const formulaElement = document.getElementById("formula");
    if (!formulaElement) {
      setMsgErro("Elemento da fórmula não encontrado");
      setLoadingFormula(false);
      return;
    }

    // Simular salvamento de imagem da fórmula (a lógica pode variar conforme necessário)
    setTimeout(() => {
      setShowModal(false);
      setImage(value); // Você pode salvar diretamente o valor da fórmula aqui
      setLoadingFormula(false);
    }, 1000);
  };

  return (
    <>
      {showModal && (
        <Modal
          show={showModal}
          dialogClassName="modal_width"
          onHide={() => setShowModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Adicionar Fórmula</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div style={{ width: "100%" }}>
              {msgErro && (
                <div
                  className="alert alert-danger alert-dismissible fade show mb-0 w-100"
                  role="alert"
                >
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setMsgErro("")}
                  ></button>
                  <p style={{ marginBottom: 0 }}>{msgErro}</p>
                </div>
              )}

              <p>Digite sua fórmula abaixo:</p>
              <textarea
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="Digite sua fórmula em LaTeX"
                rows={3}
                style={{ width: "100%" }}
              ></textarea>

              <div
                id="formula"
                style={{
                  marginTop: "20px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <BlockMath>{value || "Pré-visualização aqui"}</BlockMath>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            {loadingFormula ? (
              <div className="w-100 d-flex justify-content-center">
                <CircularProgress />
              </div>
            ) : (
              <div className="w-100 d-flex justify-content-between">
                <DefaultButton
                  type="button"
                  onClick={() => setShowModal(false)}
                  bg="secondary"
                  text="Voltar"
                />
                <DefaultButton
                  onClick={(e) => {
                    handleSaveFormula(e);
                    return undefined;
                  }}
                  bg="confirm"
                  text="Salvar fórmula"
                />
              </div>
            )}
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default ModalFormula;
